import React from 'react';
import ReactDOM from 'react-dom';
import { Text } from "react-native";
import Field from './components/Field';
import Pacient from './objects/Pacient';
import ReactDOMServer from 'react-dom/server'

class App extends React.Component {
    constructor(props) {
        super(props)
        this.pct = new Pacient();
        this.handleChange = this.handleChange.bind(this);
        this.buttonClick = this.buttonClick.bind(this);
        this.showForm = true

        this.initialPage = this.mainPage()
        this.activeView = this.initialPage

        console.log("App constructor called.");
    }

    handleChange(event) {
        let changedField = event.target.name;
        let fieldValue = event.target.value;
        let changeCategory = event.target.parentElement.parentElement.id

        this.pct[changeCategory][changedField] = fieldValue;

        if (changedField === 'birthday') {
            var today = new Date()
            var birthYear = parseInt(fieldValue.substring(0, 4))
            var birthMonth = parseInt(fieldValue.substring(5, 7))
            var birthDay = parseInt(fieldValue.substring(8))

            var birthDate = new Date(birthYear + '-' + birthMonth + '-' + birthDay)
            console.log(birthDate);

            var age = today.getTime() - birthDate.getTime()
            var elapsed = new Date(age)
            var year = elapsed.getYear() - 70;
            var month = elapsed.getMonth();
            var day = elapsed.getDay();

            this.pct.id['age'] = year + " anos, " + month + " meses e " + day + " dias."
            console.log(document.getElementById('age'));
            document.getElementById('age').innerHTML = "<b>Idade:</b> " + this.pct.id['age']
        }

        if (changedField === 'height' || changedField === 'weight') {
            this.pct.objective['antropometria'][changedField] = fieldValue
            if (this.pct.objective['antropometria']['weight'] !== 0 && this.pct.objective['antropometria']['height'] != 0) {
                let imc = this.pct.objective['antropometria']['weight'] / (this.pct.objective['antropometria']['height'] * this.pct.objective['antropometria']['height'])
                this.pct.objective.antropometria['bmi'] = imc.toFixed(2)
                document.getElementById('bmi').innerHTML = "<b>IMC:</b> " + imc.toFixed(2)
            }
        }
    }

    PrintElem(htmlString) {
        var mywindow = window.open('');

        mywindow.document.write('<html><head><title>' + document.title + '</title><link rel="stylesheet" href="https://sergio-lp.github.io/assets/page.css"/>');
        mywindow.document.write('</head><body>');
        mywindow.document.write(htmlString);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.addEventListener('load', function () {
            mywindow.print();
        })

        return true;
    }

    dataPage() {
        console.log("Rendering data page...");

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = dd + '/' + mm + '/' + yyyy;

        let layout = (
            <div className='print-root' id='printRoot'>
                <div className='header'>
                    <img width='120px' height='120px' className='img-unicamp' src="https://sergio-lp.github.io/assets/unicamp-logo.png" alt="Logo unicamp" />
                    <span className='header-title'>{today}</span>
                    <span className='header-title'>{this.pct.ubs}</span>
                    <img width='120px' height='115px' className='img-fcm' src="https://sergio-lp.github.io/assets/fcm-logo-small.png" alt="Logo FCM" />
                </div>

                <div className='content' style={{ marginTop: '30px' }}>
                    <div className='card'>
                        <div className='container'>
                            <h1 className='title'>Identificação</h1><br />
                            <b>Nome: </b>{this.pct.id['name']}<br /><br />
                            <b>Data de nascimento: </b>{this.pct.id['birthday']}<br /><br />
                            <b>Idade: </b>{this.pct.id['age']}<br /><br />
                            <b>Acompanhante: </b>{this.pct.id['companion']}<br /><br />
                            <b>Etnia: </b>{this.pct.id['ethnicity']}<br /><br />
                            <b>Naturalidade: </b>{this.pct.id['bornAt']}<br /><br />
                            <b>Procedência: </b>{this.pct.id['residence']}<br /><br />
                        </div>
                    </div>
                    <div className='card'>
                        <div className='container'>
                            <h1 className='title'>Subjetivo</h1><br />
                            <b>Queixa principal: </b><br />{this.pct.subjective['qp'].split('\n').map(str => <p>{str}</p>)}<br />
                            <b>HPMA: </b><br />{this.pct.subjective['hpma'].split('\n').map(str => <p>{str}</p>)}<br />
                            <b>Interrogatório sobre os diversos aparelhos: </b><br />{this.pct.subjective['ic'].split('\n').map(str => <p>{str}</p>)}<br />
                            <b>Antecedentes pessoais: </b><br />{this.pct.subjective['ap'].split('\n').map(str => <p>{str}</p>)}<br />
                            <b>Situação vacinal: </b><br />{this.pct.subjective['vaccine'].split('\n').map(str => <p>{str}</p>)}<br />
                            <b>Ingesta alimentar: </b><br />{this.pct.subjective['foodIntake'].split('\n').map(str => <p>{str}</p>)}<br />
                            <b>DNPM e social: </b><br />{this.pct.subjective['neurologic'].split('\n').map(str => <p>{str}</p>)}
                        </div>
                    </div>
                    <div className='card'>
                        <div className='container'>
                            <h1 className='title'>Objetivo</h1><br />
                            <b>Peso: </b>{this.pct.objective['antropometria']['weight']}<br />
                            <b>Altura: </b>{this.pct.objective['antropometria']['height']}<br />
                            <b>IMC: </b>{this.pct.objective['antropometria']['bmi']}<br /><br />
                            <b>Sinais vitais: </b><br />{this.pct.objective['ssvv'].split('\n').map(str => <p>{str}</p>)}<br />
                            <b>Exame físico geral: </b><br />{this.pct.objective['overall'].split('\n').map(str => <p>{str}</p>)}<br />
                            <b>Exame físico específico: </b><br />{this.pct.objective['specific'].split('\n').map(str => <p>{str}</p>)}<br />
                        </div>
                    </div>
                    <div className='card'>
                        <div className='container'>
                            <h1 className='title'>Avaliação</h1><br />
                            <b>Hipóteses diagnósticas: </b><br />{this.pct.evaluation['evaluation'].split('\n').map(str => <p>{str}</p>)}<br />
                        </div>
                    </div>
                    <div className='card'>
                        <div className='container'>
                            <h1 className='title'>Plano</h1><br />
                            <b>Conduta: </b><br />{this.pct.procedure['procedure'].split('\n').map(str => <p>{str}</p>)}<br />
                        </div>
                    </div>

                    <button onClick={this.buttonClick} className='button'>SALVAR</button>
                </div>
            </div>
        )


        return layout
    }

    buttonClick(event) {
        if (this.showForm) {
            this.showForm = false;
            this.PrintElem(ReactDOMServer.renderToString(this.dataPage()))
            //this.activeView = this.dataPage();
        } else {
            this.showForm = true;
            this.activeView = this.initialPage;
        }

        event.preventDefault();
    }

    mainPage() {
        console.log("Rendering app...");

        let idFields = []

        //ID
        idFields.push(Field('name', 'text', true, 'Nome do paciente...', this.handleChange));
        idFields.push(Field('cns', 'text', true, 'CNS/Prontuário...', this.handleChange));
        idFields.push(Field('birthday', 'date', true, 'Data de nascimento...', this.handleChange));
        idFields.push(<div className='input' id='age' style={{ padding: '3px' }}><b>Idade:</b> </div>)
        idFields.push(Field('companion', 'text', false, 'Acompanhante...', this.handleChange));
        idFields.push(Field('ethnicity', 'text', true, 'Etnia...', this.handleChange));
        idFields.push(Field('bornAt', 'text', true, 'Naturalidade...', this.handleChange));
        idFields.push(Field('residence', 'text', true, 'Procedência...', this.handleChange));

        //SUBJETIVO

        let subFields = []
        subFields.push(Field('qp', 'textarea', true, 'Queixa principal', this.handleChange))
        subFields.push(Field('hpma', 'textarea', true, 'HPMA', this.handleChange))
        subFields.push(Field('ic', 'textarea', true, 'IC', this.handleChange))
        subFields.push(Field('ap', 'textarea', true, 'Antecedentes', this.handleChange))
        subFields.push(Field('vaccine', 'textarea', true, 'Status vacinal', this.handleChange))
        subFields.push(Field('foodIntake', 'textarea', true, 'Alimentação', this.handleChange))
        subFields.push(Field('neurologic', 'textarea', true, 'DNPM e social', this.handleChange))

        let objFields = []
        objFields.push(Field('weight', 'number', true, 'Peso...', this.handleChange));
        objFields.push(Field('height', 'number', true, 'Altura...', this.handleChange));
        objFields.push(<div className='input' id='bmi' style={{ padding: '3px' }}><b>IMC: </b> </div>)
        objFields.push(Field('ssvv', 'textarea', true, 'Sinais vitais', this.handleChange, "FC: bpm\nFR: irpm\nPA: mmHg"))
        objFields.push(Field('overall', 'textarea', true, 'Exame físico geral', this.handleChange, "BEG, CHAAA, afebril, ativo."))
        objFields.push(Field('specific', 'textarea', true, 'Exame físico específico', this.handleChange, "Cabeça: \nPescoço: \nTórax: \nAbdome: \nGenitais: \nMembros: "))

        let evalFields = []
        evalFields.push(Field('evaluation', 'textarea', true, 'Hipóteses diagnósticas', this.handleChange, "VACINAL: Em dia (sic).\nNUTRICIONAL: Eutrófico. \nDNPM E SOCIAL: Adequado para a idade. \nESPECÍFICO/PATOLÓGICO: ."))

        let procFields = []
        procFields.push(Field('procedure', 'textarea', true, 'Condutas e procedimentos', this.handleChange, ""))

        let form = (
            <div id='main-form'>
                <form onSubmit={this.handleSubmit}>
                    <div className='card'>
                        <div className='container' id='id'>
                            <h1 className='title'>Identificação</h1><br />
                            {idFields}
                        </div>
                    </div>
                    <div className='card'>
                        <div className='container' id='subjective'>
                            <h1 className='title'>Subjetivo</h1><br />
                            {subFields}
                        </div>
                    </div>
                    <div className='card'>
                        <div className='container' id='objective'>
                            <h1 className='title'>Objetivo</h1><br />
                            {objFields}
                        </div>
                    </div>
                    <div className='card'>
                        <div className='container' id='evaluation'>
                            <h1 className='title'>Avaliação</h1><br />
                            {evalFields}
                        </div>
                    </div>
                    <div className='card'>
                        <div className='container' id='procedure'>
                            <h1 className='title'>Plano</h1><br />
                            {procFields}
                        </div>
                    </div>
                    <button type='submit' className='button' onClick={this.buttonClick}>SALVAR</button>

                </form>
            </div >
        );

        return form;
    }

    render() {
        return this.activeView
    }


}

export default App